var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M54.8 60H5.2C2.3 60 0 57.5 0 54.4v-28c0-.4.2-.8.5-1.1L29 .4a1.52 1.52 0 0 1 2 0l28.5 24.9c.3.3.5.7.5 1.1v28c0 3.1-2.3 5.6-5.2 5.6zM3 27.1v27.3C3 55.9 4 57 5.2 57h49.6c1.2 0 2.2-1.2 2.2-2.6V27.1L30 3.5 3 27.1zm48.4 25.8c-.3 0-.7-.1-1-.4L38.3 42.2H21.7L9.6 52.5c-.6.6-1.6.5-2.1-.2s-.5-1.5.2-2l12.6-10.7c.3-.2.6-.4 1-.4h17.6c.4 0 .7.1 1 .4l12.6 10.7c.6.5.7 1.5.2 2.1-.5.3-.9.5-1.3.5z","key":0}),React.createElement("path",{"d":"M44.3 38.6c-.4 0-.9-.2-1.2-.6-.5-.7-.4-1.6.3-2.1l14.3-10.7c.7-.5 1.6-.4 2.1.3s.4 1.6-.3 2.1L45.1 38.3c-.2.2-.5.3-.8.3zm-28.6 0c-.3 0-.6-.1-.9-.3L.6 27.6c-.7-.5-.8-1.4-.3-2.1s1.4-.8 2.1-.3l14.3 10.7c.7.5.8 1.4.3 2.1-.4.4-.8.6-1.3.6z","key":1})]);
}

Envelope.defaultProps = {"baseProfile":"tiny","viewBox":"0 0 60 60","overflow":"visible"};

module.exports = Envelope;

Envelope.default = Envelope;
